import { TCheckboxChangeEvent } from '@portals/ui-kit';

export enum EFeedbackModalOption {
  NOT_ACTUAL = 'irrelevant_info',
  CAN_NOT_UNDERSTAND = 'unclear',
  HARD_TO_UNDERSTAND = 'difficult_to_understand',
  USELESS = 'useless_info',
}

export type TFeedbackOptions = Record<
  EFeedbackModalOption,
  TCheckboxChangeEvent
>;
export type TFeedbackData = TFeedbackOptions & {
  comment?: string;
};
